export type FingerprintableEvent = {
  id: number
  room_id?: string
  start_time: string | Date
  end_time: string | Date
  updated_at?: string
  emr_updated_at?: string | null
  sms_notification?: string | number
  temperature?: number | null
  consultation_staff?: number
  consultation_staff_name?: string
  current_location?: string | null
  status?: { code?: number }
  category?: { code?: number }
  title?: string
}

const toFingerprintTime = (value: string | Date): string | number =>
  value instanceof Date ? value.getTime() : value

/**
 * A stable string capturing every display-relevant field of a single schedule event.
 * Used both to dedupe the data source and to detect which events actually changed
 * between two snapshots, so only those get re-rendered.
 */
export const fingerprintScheduleEvent = (event: FingerprintableEvent): string =>
  [
    event.id,
    event.room_id,
    toFingerprintTime(event.start_time),
    toFingerprintTime(event.end_time),
    event.updated_at ?? '',
    event.emr_updated_at ?? '',
    event.status?.code ?? '',
    event.category?.code ?? '',
    event.title ?? '',
    event.sms_notification ?? '',
    event.temperature ?? '',
    event.consultation_staff ?? '',
    event.consultation_staff_name ?? '',
    event.current_location ?? '',
  ].join('|')
